import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardField from 'shared/StandardField.jsx';
import StandardModal from 'shared/StandardModal.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const CaptainDetailUpdateModal = ({
  visible,
  onCancelClick,
  handleSubmit,
  onSubmit
}) =>
(
  <StandardModal
    title="Update Captain"
    visible={visible}
    onCloseClick={onCancelClick}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ErrorListContainer />
        <input type="hidden"
          name="captainId" />
        <div className="row">
          <div className="col-sm-6">
          <Field name="captainFirstName"
            type="text"
            component={StandardField}
            placeholder="First Name"/>
          </div>
          <div className="col-sm-6">
          <Field name="captainLastName"
            type="text"
            component={StandardField}
            placeholder="Last Name"/>
          </div>
        </div>
        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => onCancelClick()}
          >{'Cancel'}</button>
          {` `}
          <button
            type="submit"
            className="btn btn-primary btn-lg"
          ><i className="fa fa-floppy-o" /> {'Save'}</button>
        </div>
      </form>
  </StandardModal>
);

CaptainDetailUpdateModal.propTypes = {
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default reduxForm({
  form: 'adminCaptainDetailUpdateForm'
})(CaptainDetailUpdateModal);



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainDetailUpdateModal.jsx